/**
 * What a program card is called, in the two places a name is needed.
 *
 * A card face is `--card-w` wide -- 3.5rem -- so a name drawn ON a card
 * has to fit it, and the glyph and priority beside it already say which
 * way the robot turns. A name in a SENTENCE has room and needs the verb:
 * the log writes "Ratchet plays Rotate Left (priority 90)", where a bare
 * "Left" reads as a fragment.
 *
 * Only the two rotations differ, so the long map overrides that pair.
 */

/** On a card face, a register slot, or the strip. Short enough to fit. */
export const CARD_LABEL: Record<string, string> = {
  UTurn: 'U-Turn',
  RotateLeft: 'Left',
  RotateRight: 'Right',
  BackUp: 'Back Up',
  Move1: 'Move 1',
  Move2: 'Move 2',
  Move3: 'Move 3',
};

/** In prose -- the log, and anywhere a card is named in a sentence. */
export const CARD_LABEL_LONG: Record<string, string> = {
  ...CARD_LABEL,
  RotateLeft: 'Rotate Left',
  RotateRight: 'Rotate Right',
};

/** An Option named under a register card, on the programming screen and
 * the strip, by effect, where the full name does not fit. The tooltip
 * keeps the full name. */
export const OPTION_SLOT_NAME: Record<string, string> = {
  bootlegger: 'Bootleg',
  bridgeLayer: 'Bridge',
  crabLegs: 'Crab',
  dualProcessor: 'D. Proc.',
  emergencyBrake: 'E. Brake',
  empGenerator: 'EMP',
  enhancedSteering: 'E. Steer',
  flameThrower: 'F. Throw',
  flamingOilDropper: 'F. Oil',
  fourthGear: '4th Gear',
  gooDropper: 'Goo',
  hardTurn: 'H. Turn',
  mineLayer: 'Mines',
  oilDropper: 'Oil',
  overloadOverride: 'O. Over',
  portableTeleporter: 'P. Telep',
  proximityMine: 'P. Mine',
  reverseGears: 'R. Gears',
  scandinavianFlick: 'S. Flick',
  scramblerBomb: 'S. Bomb',
  seismicCharge: 'Seismic',
  serpentine: 'Serpent',
  slingshot: 'Sling',
  smokeDropper: 'Smoke',
  smokeGenerator: 'Smoke G.',
  spikeDropper: 'Spikes',
  waterDropper: 'Water',
};
